import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './logo.svg';
import loginButton from './login_button.svg';
import phone from './Phone.svg';


export const OnboardingHeader = () => (
  <div className="py-5 px-10 row align-items-center mx-auto onboarding-header">
    <div className="onboarding-logo">
      <a href="https://dreamitreel.com" className="navbar-brand">
        <img alt="Dream it Reel Logo" src={Logo} />
      </a>
    </div>
    <div className="mobile-onboarding-controls">
      <div className="onboarding-phone">
        <a href="tel:855-431-7335">
          <img alt="Phone Number" src={phone} />
        </a>
      </div>
      <div className="separator d-lg-inline-block" />
      <div className="login-button">
        <a href="/login">
          <img src={loginButton} />
        </a>
      </div>
    </div>
    <div className="row align-self-center mobile-responsive">
      <div className="questions-text">
       {/* Questions?&nbsp;
        <a href="tel:855-431-7335">
          <span className="btn-txt">(855) 431-7335</span>
        </a>*/}
        {/*&nbsp;|&nbsp;*/}
        <Link style={{color: "#259F96"}} to="/login">Sign In</Link>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/OnboardingRedesign/OnboardingHeader.js